import type { LotStoryProjectionTimelineEvent } from '../../types/lotStory'

export type StoryTimelineFilter = 'all' | 'notes-only' | 'relationship-only'

const isRelationshipEvent = (event: LotStoryProjectionTimelineEvent): boolean => (
  event.eventType === 'split' || event.eventType === 'merge'
)

const hasOperatorNotes = (event: LotStoryProjectionTimelineEvent): boolean => (
  typeof event.notes === 'string' && event.notes.trim().length > 0
)

export const buildFilteredStoryTimelineEvents = (args: {
  events: LotStoryProjectionTimelineEvent[]
  filter: StoryTimelineFilter
}): LotStoryProjectionTimelineEvent[] => {
  if (args.filter === 'all') {
    return args.events
  }

  if (args.filter === 'notes-only') {
    return args.events.filter((event) => hasOperatorNotes(event))
  }

  return args.events.filter((event) => isRelationshipEvent(event))
}